/* Rippl shop, collections and search (14 Oct 2026). Source: theme-build/shop/assets/rsh-shop.js
   - Range tabs (All, Water filtration, Rippl mineral water, Rippl Pure filters) show and hide groups; #filtration etc. open a tab.
   - Sort: Featured (the block order), price low to high, high to low, inside each group. The custom branded door stays last.
   - "+" adds to the cart the theme's own way (cart/add.js with the drawer's sections, then cart:change opens the drawer, as
     Prestige's product form does). Without script, the form posts to /cart/add and Shopify opens the cart.
   - Search: results follow the typing (Section Rendering API, the same section re-rendered for the new words). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- collection: tabs and sort ---------- */
  var shop = document.querySelector('.rsh[data-view]');
  if (shop) {
    var V = {};
    try { V = JSON.parse(shop.querySelector('#rsh-views').innerHTML); } catch (e) {}
    var tabs = [].slice.call(shop.querySelectorAll('.rsh-tabs [data-v]'));
    var groups = [].slice.call(shop.querySelectorAll('.rsh-group'));
    var h1 = shop.querySelector('#rsh-h'), lede = shop.querySelector('#rsh-lede'), count = shop.querySelector('#rsh-count');
    var sel = shop.querySelector('[data-rsh-sort]');
    var full = shop.getAttribute('data-full') === 'true';
    var view = shop.getAttribute('data-view') || 'all';

    var show = function (v, push) {
      if (!V[v]) v = 'all';
      view = v;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-v') === v ? 'true' : 'false'); });
      var n = 0;
      groups.forEach(function (g) {
        var on = !full || V[v].keys.indexOf(g.getAttribute('data-g')) > -1;
        g.hidden = !on;
        if (on) n += g.querySelectorAll('.rsh-card').length;
      });
      if (full && h1) {
        h1.textContent = V[v].h;
        if (lede) { lede.textContent = V[v].lede; lede.hidden = !V[v].lede; }
      }
      if (count) count.textContent = n + (n === 1 ? ' product' : ' products');
      if (push) { try { history.replaceState(null, '', v === 'all' ? location.pathname + location.search : '#' + v); } catch (e) {} }
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-v'), true); }); });
    var fromHash = function () {
      var hv = location.hash.slice(1);
      if (tabs.length && V[hv] && shop.querySelector('.rsh-tabs [data-v="' + hv + '"]')) show(hv, false);
    };
    fromHash();
    addEventListener('hashchange', fromHash);

    if (sel) sel.addEventListener('change', function () {
      var how = sel.value;
      [].slice.call(shop.querySelectorAll('[data-rsh-grid]')).forEach(function (grid) {
        var cards = [].slice.call(grid.querySelectorAll(':scope > .rsh-card'));
        cards.sort(function (a, b) {
          if (how === 'low') return (+a.dataset.price - +b.dataset.price) || (+a.dataset.i - +b.dataset.i);
          if (how === 'high') return (+b.dataset.price - +a.dataset.price) || (+a.dataset.i - +b.dataset.i);
          return +a.dataset.i - +b.dataset.i;
        });
        var door = grid.querySelector(':scope > .rsh-door');
        cards.forEach(function (c) { grid.insertBefore(c, door); });
      });
    });
  }

  /* ---------- "+" add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-rsh-add]')) return;
    if (!window.fetch || !window.FormData || !document.querySelector('cart-drawer')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var old = form.parentNode.parentNode.querySelector('.rsh-err');
    if (old) old.remove();
    var secs = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: secs } }));
    var fd = new FormData(form);
    if (secs.length) { fd.set('sections', secs.join(',')); fd.set('sections_url', root + 'variants/' + fd.get('id')); }
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = item.sections || {};
          btn.setAttribute('data-done', ''); btn.firstChild.textContent = '✓';
          setTimeout(function () { btn.removeAttribute('data-done'); btn.firstChild.textContent = '+'; }, 2000);
          if (!secs.length) { location.href = root + 'cart'; return; }
          form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [item], cart: cart, onSuccessDo: 'force_open_drawer' } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          setTimeout(function () { var d = document.querySelector('cart-drawer'); if (!d || !d.hasAttribute('open')) location.href = root + 'cart'; }, 900);
        });
      })
      .catch(function (err) {
        var m = document.createElement('p');
        m.className = 'rsh-err'; m.setAttribute('role', 'alert');
        m.textContent = (err && (err.description || (typeof err.message === 'string' && err.message !== 'Cart Error' && err.message))) || 'That did not go through. Please try again.';
        form.closest('.rsh-card').querySelector('.rsh-meta').appendChild(m);
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- search: results follow the typing ---------- */
  var sform = document.querySelector('form[data-rsh-search]');
  if (sform && window.fetch && window.DOMParser) {
    var input = sform.querySelector('input[name=q]'), res = document.getElementById('rsh-res'), sid = sform.getAttribute('data-section'), t = 0, ctl = null, last = input.value.trim();
    var run = function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      var u = new URL(sform.action, location.origin);
      [].slice.call(sform.querySelectorAll('input[type=hidden]')).forEach(function (h) { u.searchParams.set(h.name, h.value); });
      u.searchParams.set('q', q);
      var pageUrl = u.pathname + u.search;
      u.searchParams.set('section_id', sid);
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      res.setAttribute('aria-busy', 'true');
      fetch(u.toString(), ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('rsh-res');
        if (fresh) res.innerHTML = fresh.innerHTML;
        res.removeAttribute('aria-busy');
        try { history.replaceState(null, '', q ? pageUrl : u.pathname); } catch (e) {}
      }).catch(function () { res.removeAttribute('aria-busy'); });
    };
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 260); });
    [].slice.call(document.querySelectorAll('.rsh-sug [data-q]')).forEach(function (c) {
      c.addEventListener('click', function (e) { e.preventDefault(); input.value = c.getAttribute('data-q'); clearTimeout(t); run(); input.focus(); });
    });
    sform.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
      e.preventDefault(); clearTimeout(t); last = null; run();
    });
  }
})();
